import { getTemplateList, getClientApp, getRoleAll, getAgentAll, findMe } from '@/api/api';
import store from 'store';

// test
export const getAllTemplates = async ({ commit }) => {
  const res = await getTemplateList({
    page: 1,
    size: 10
  });
  commit('setTemplates', res.list);
};

export const getClientAppMsg = async ({ commit }, params) => {
  const data = await getClientApp({
    clientAppId: params.appId,
    wechatAppId: params.wechatAppId
  });
  if (!data) return;
  commit('setClientAppMsg', {
    appId: data.appId,
    appTitle: data.title,
    bindApp: data.bindApp,
    extAppid: (data.bindApp && data.bindApp.appId) || '',
    typehood: data.extra.typehood,
    weappTemplate: data.extra.weappTemplate
  });
};

export const getPeopleAll = async ({ commit }) => {
  const res = await getRoleAll({});
  if (!res) return;
  commit('setPeopleAll', res);
};

export const getAutoSetStep = async ({ commit }, step) => {
  commit('setAutoSetStep', step);
};

export const getAgents = async ({ commit }) => {
  const res = await getAgentAll({});
  if (!res) return;
  commit('getAgentsList', res);
};

export const checkAgentAuth = async ({ commit }) => {
  let res = null;
  const haveChecked = sessionStorage.getItem('haveChecked');
  if (haveChecked) {
    res = store.get('me');
  } else {
    res = await findMe({});
  }
  if (!res) return;
  if (!haveChecked) {
    store.set('me', res);
  }
  commit('checkAgent', res);
};
